<template>
  <v-app>
    <v-app-bar v-if="$route.name != 'Convencion'" flat app color="#FFFFFF">
      <v-app-bar-nav-icon @click="drawer = true" class="d-flex d-md-none"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-col md="5" lg="4">
        <v-toolbar-title class="">
          <v-img
            alt="Konecta logo"
            class="mt-1 pointer-path mx-9"
            contain
            :src="require(`./assets/newlanding/Landing/${this.logo.img}`)"
            :max-width="this.logo.size"
            @click="
              () => {
                $router.push('/');
              }
            "
          />
        </v-toolbar-title>
      </v-col>
      <v-spacer></v-spacer>
      <v-col md="7" lg="8" xl="5" class="d-none d-md-block">
        <v-row>
          <v-col v-for="(item, index) in itemsNavbar" :key="index">
            <Menu
              :title="item.title"
              :items="item.items"
              :isSelect="item.isSelect"
              :path="item.path"
              :tag="item.tag"
              :classString="item.classString"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-spacer v-if="!isMobile"></v-spacer>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app temporary class="pt-12">
      <Expand
        title="Sobre nosotros"
        :items="[
          { title: '¿Quiénes somos?', path: '/reconocimientos' },
          { title: 'Conoce nuestras sedes', path: '/sedes' },
        ]"
      >
      </Expand>
      <Expand
        title="Nuestros beneficios"
        :items="[
          { title: 'Beneficios', path: '/beneficios' },
          { title: 'Nuestros programas', path: '/programas' },
        ]"
      >
      </Expand>
      <Expand title="Oportunidades laborales" :expanded="false" path="/empleos"></Expand>
      <template v-slot:append>
        <img
          alt="Konecta"
          :src="require('./assets/newlanding/Landing/logo-navbar.svg')"
          width="126"
          class="ml-15 pb-7"
        />
      </template>
    </v-navigation-drawer>
    <v-main>
      <router-view :isMobile="isMobile"></router-view>
    </v-main>
    <v-footer
      v-if="$route.name == 'home'"
      padless
      color="#F2F3F7"
      class="px-md-15 py-md-15 white--text py-6 px-4 px-xl-15"
    >
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" class="ml-5 ml-md-0" md="6" lg="5">
              <img
                alt="Konecta test"
                :src="require(`./assets/newlanding/Landing/${this.logo.img}`)"
                :width="isMobile ? '156' : '300'"
                class=""
              />
              <p class="description-footer py-9">Feel the pulse</p>
            </v-col>
            <v-col cols="12" md="6" lg="7">
              <v-row no-gutters>
                <v-col cols="12" md="4" v-for="i in itemsFooter" :key="i.title">
                  <div class="ml-5 mb-12 mt-4">
                    <p class="title-item-footer">{{ i.title }}</p>
                    <div v-for="e in i.items" :key="e.name">
                      <p class="subtitle-item-footer" @click="handleRedirection(e.event, e.about)">{{ e.name }}</p>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-md-15">
          <v-row no-gutters>
            <v-col cols="12" class="d-none d-md-block" md="6" lg="5">
              <p class="mb-0 sentence-footer">© {{ currentYear }} Konecta Perú. Todos los derechos reservados.</p>
            </v-col>
            <v-col cols="12" md="6" lg="7">
              <v-row no-gutters class="ml-5">
                <v-col cols="12" md="4" lg="3" xl="2">
                  <p class="sentence-footer">Síguenos</p>
                </v-col>
                <v-col cols="12" md="6" lg="7">
                  <div class="">
                    <v-icon
                      color="#98A2B3"
                      class="icon-social-media mr-2"
                      v-for="icon in iconsSocialMedia"
                      @click="handleOpenSocialMedia(icon.link)"
                      :key="icon.icon"
                    >
                      {{ icon.icon }}</v-icon
                    >
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="d-flex align-center justify-center py-15 d-md-none">
              <p class="mb-0 sentence-footer">© {{ currentYear }} Konecta Perú. Todos los derechos reservados.</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-footer>
    <div>
      <UpdateVersion />
    </div>
    <v-fab-transition
      class="postula"
      v-if="!pathSelect.includes('/empleos') && !pathSelect.includes('/selection') && !pathSelect.includes('/sedes')"
    >
    </v-fab-transition>
  </v-app>
</template>

<script>
import Expand from "./components/NewLanding/NavBar/Expand.vue";
import Menu from "./components/NewLanding/NavBar/Menu.vue";
import UpdateVersion from "./components/UpdateVersion.vue";

export default {
  name: "App",
  components: {
    Menu,
    Expand,
    UpdateVersion,
  },
  data() {
    return {
      pathSelect: "",
      drawer: false,
      group: null,
      version: {
        nroVersion: "",
      },
      itemsNavbar: [
        {
          title: "Sobre nosotros",
          items: [
            { title: "¿Quiénes somos?", path: "/reconocimientos", tag: "Quienessomos" },
            { title: "Conoce nuestras sedes", path: "/sedes", tag: "Conocenuestrassedes" },
          ],
          isSelect: true,
          path: "",
        },
        {
          title: "Nuestros beneficios",
          path: "",
          items: [
            { title: "Beneficios", path: "/beneficios", tag: "Beneficios" },
            { title: "Nuestros programas", path: "/programas", tag: "Nuestrosprogramas" },
          ],
          isSelect: true,
        },
        {
          title: "Oportunidades laborales",
          path: "/empleos",
          tag: "Konectaempleos",
          isSelect: false,
        },
      ],
      itemsFooter: [
        {
          title: "Konecta Perú",
          items: [
            {
              event: "/reconocimientos",
              name: "¿Quiénes somos?",
            },
            {
              event: "/sedes",
              name: "Nuestras sedes",
            },
            {
              about: "_blank",
              event: "https://www.konecta-group.com/es/quienes-somos",
              name: "Nuestros principios rectores",
            },
          ],
        },
        {
          title: "Conectamos contigo",
          items: [
            {
              event: "/beneficios",
              name: "Beneficios",
            },
            {
              event: "/programas",
              name: "Nuestros programas",
            },
          ],
        },
        {
          title: "Destacados",
          items: [
            {
              about: "_blank",
              event: "/",
              name: "Noticias",
            },
            {
              about: "_blank",
              event: "https://www.konecta-group.com/es/sustainability",
              name: "Sostenibilidad",
            },
          ],
        },
      ],
      iconsSocialMedia: [
        {
          link: "https://www.linkedin.com/company/grupo-konecta/",
          icon: "mdi-linkedin",
        },
        {
          link: "https://www.facebook.com/KonectaPeruOficial",
          icon: "mdi-facebook",
        },
        {
          link: "https://www.instagram.com/konectaperu/",
          icon: "mdi-instagram",
        },
        {
          link: "https://www.tiktok.com/@konectaperu",
          icon: "mdi-tiktok",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.pathSelect = to.path;
      if (to.path !== from.path) {
        window.scrollTo(0, 0);
      }
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    logo() {
      const size = this.isMobile ? "126" : "320";
      return {
        img: "logo-new-version.png",
        size,
      };
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    trackBtnApply() {
      this.$gtag?.event("LP_btn_Icono_Postula", {
        event_category: "LP_btn_Icono_Postula",
        event_label: "LP_btn_Icono_Postula",
        value: 1,
      });
      this.$router.push("/empleos");
    },
    handleRedirection(url, about) {
      if (about) window.open(url, about);
      else this.$router.push(url);
    },
    handleOpenSocialMedia(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_app.scss";

.social-btn {
  background-color: #3c23ff !important ; /* Morado corporativo */
  transition: transform 0.2s;
}

.social-btn:hover {
  transform: scale(1.1);
}

.img-btn {
  width: 100px;
  height: 100px;
}
.postula {
  margin: 90px 25px !important;
  &:hover {
    transform: translate(0, -15px);
  }
}
.container-icon-social-media {
  background: none;
  text-transform: none;
}
.icon-social-media {
  width: 24px;
  cursor: pointer;
}
.title-item-footer {
  font-family: $principal-font !important;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}

.subtitle-item-footer {
  cursor: pointer;
  font-family: $principal-font !important;

  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
.sentence-footer {
  font-family: $principal-font !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 24px;
  color: #000000;
}
.description-footer {
  margin: 1% 0%;
  max-width: 320px;
  font-family: $principal-font !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* or 125% */

  color: #000000;
}
.pointer-path {
  cursor: pointer;
  font-family: $principal-font !important;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #101828;
}
.btn-work {
  @media (max-width: 600px) {
    font-size: 10px;
  }
}
.grecaptcha-badge {
  visibility: hidden;
}
.btn-bolsa {
  width: 180px;
  font-weight: 600;
  font-size: 20px;
  border-radius: 10px;
  border: 2px solid;
  @media (min-width: 600px) {
    width: 220px;
    margin: 0px 5px 0px 20px;
  }
  span {
    font-size: 10px;
    @media (min-width: 600px) {
      font-size: 12px;
    }
  }
}
.mainK {
  margin-top: 50px;
  width: 100vw;
}
.app {
  width: 100vw !important;
}
.v-dialog {
  max-width: 500px !important;
}
@media screen and (max-width: 600px) {
  .v-dialogal {
    max-width: 350px !important;
  }
}

@media (min-width: 600px) {
  .title-item-footer {
    color: #000000;
  }

  .sentence-footer {
    font-size: 14px !important;
  }
}
@media (min-width: 900px) {
  .img-btn {
    width: 140px;
    height: 140px;
  }
  .postula {
    margin: 80px 50px !important;
    &:hover {
      transform: translate(0, -15px);
    }
  }
}
/* --- TikTok brand icon in the MDI “slot” --- */
.mdi.mdi-tiktok::before {
  content: "";
  display: inline-block;
  width: 1em; /* mismo tamaño que otras MDI */
  height: 1em;
  background-color: currentColor; /* se pinta con v-icon color */
  /* ▼ máscara SVG (Ionicons) */
  -webkit-mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M412.19 118.66a109.27 109.27 0 0 1-9.45-5.5 132.87 132.87 0 0 1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14 23.9 350 16 350.13 16H267.69V334.78c0 4.28 0 8.51-.18 12.69 0 .52-.05 1-.08 1.56 0 .23 0 .47-.05.71 0 .06 0 .12 0 .18a70 70 0 0 1-35.22 55.56 68.8 68.8 0 0 1-34.11 9c-38.41 0-69.54-31.32-69.54-70s31.13-70 69.54-70a68.9 68.9 0 0 1 21.41 3.39l.1-83.94a153.14 153.14 0 0 0-118 34.52 161.79 161.79 0 0 0-35.3 43.53c-3.48 6-16.61 30.11-18.2 69.24-1 22.21 5.67 45.22 8.85 54.73v.2c2 5.6 9.75 24.71 22.38 40.82A167.53 167.53 0 0 0 115 470.66v-.2l.2.2C155.11 497.78 199.36 496 199.36 496c7.66-.31 33.32 0 62.46-13.81 32.32-15.31 50.72-38.12 50.72-38.12a158.46 158.46 0 0 0 27.64-45.93c7.46-19.61 9.95-43.13 9.95-52.53V176.49c1 .6 14.32 9.41 14.32 9.41s19.19 12.3 49.13 20.31c21.48 5.7 50.42 6.9 50.42 6.9V131.27c-.44 1.1-21.03-2.1-42.11-12.61Z'/></svg>")
    center/contain no-repeat;
  mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M412.19 118.66a109.27 109.27 0 0 1-9.45-5.5 132.87 132.87 0 0 1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14 23.9 350 16 350.13 16H267.69V334.78c0 4.28 0 8.51-.18 12.69 0 .52-.05 1-.08 1.56 0 .23 0 .47-.05.71 0 .06 0 .12 0 .18a70 70 0 0 1-35.22 55.56 68.8 68.8 0 0 1-34.11 9c-38.41 0-69.54-31.32-69.54-70s31.13-70 69.54-70a68.9 68.9 0 0 1 21.41 3.39l.1-83.94a153.14 153.14 0 0 0-118 34.52 161.79 161.79 0 0 0-35.3 43.53c-3.48 6-16.61 30.11-18.2 69.24-1 22.21 5.67 45.22 8.85 54.73v.2c2 5.6 9.75 24.71 22.38 40.82A167.53 167.53 0 0 0 115 470.66v-.2l.2.2C155.11 497.78 199.36 496 199.36 496c7.66-.31 33.32 0 62.46-13.81 32.32-15.31 50.72-38.12 50.72-38.12a158.46 158.46 0 0 0 27.64-45.93c7.46-19.61 9.95-43.13 9.95-52.53V176.49c1 .6 14.32 9.41 14.32 9.41s19.19 12.3 49.13 20.31c21.48 5.7 50.42 6.9 50.42 6.9V131.27c-.44 1.1-21.03-2.1-42.11-12.61Z'/></svg>")
    center/contain no-repeat; /* Firefox */
}

.v-icon.icon-social-media {
  /* tamaño del círculo */
  width: 40px;
  height: 40px;

  /* círculo perfecto */
  border-radius: 50%;

  /* alinear el glyph al centro */
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* color de fondo y del ícono */
  background-color: #2800c8; /* tu morado corporativo */
  color: #ffffff !important; /* pictograma en blanco */

  /* hace que el glyph no sobresalga del círculo */
  font-size: 20px; /* ajusta según gusto */

  /* transiciones agradables */
  transition: background 0.25s ease, transform 0.25s ease;

  /* separaciones uniformes */
  margin-right: 1rem; /* igual al MR-6 que usas */
  cursor: pointer;
}

/* ligero “pop” al pasar el mouse */
.v-icon.icon-social-media:hover {
  background-color: #0f0f72; /* tono un poco más claro/oscuro */
  transform: translateY(-2px);
}

/* opcional: elimina el subrayado azul que Chrome pone al hacer click */
.v-icon.icon-social-media:focus {
  outline: none;
}
</style>
